import { ReactNode } from 'react';

import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

interface SupplierSubscriptionPlanPricingProps {
    price: ReactNode;
    priceNote: ReactNode;
    transactionFee: ReactNode;
    offerLabel?: string;
}

export const SupplierSubscriptionPlanPricing = ({
    price,
    priceNote,
    transactionFee,
    offerLabel,
}: SupplierSubscriptionPlanPricingProps) => (
    <Box display="grid" gridTemplateRows="20px 32px 32px auto" rowGap={4}>
        <Box minHeight={20}>
            {offerLabel ? (
                <Text variant="extraSmall" color="accent.foreground" fontWeight={600} fontStyle="italic">
                    {offerLabel}
                </Text>
            ) : null}
        </Box>
        <Box display="flex" alignItems="baseline" flexWrap="wrap" gap={8}>
            {price}
        </Box>
        <Box minHeight={32} display="flex" alignItems="baseline" flexWrap="wrap" gap={8}>
            {priceNote}
        </Box>
        <Box display="flex" flexDirection="column" gap={4} marginTop={16}>
            <Box display="flex" alignItems="baseline" flexWrap="wrap" gap={8}>
                {transactionFee}
            </Box>
            <Text variant="extraSmall" color="foreground.muted">
                {translate('supplierSubscriptionPlans.spotOrders')}
            </Text>
        </Box>
    </Box>
);
